export default "__VITE_PUBLIC_ASSET__fa14e0bc__"